// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".province-title{position:absolute;top:50px;left:150px;color:#fff}.province-info{background:#fff;position:absolute;top:150px;right:20px;height:400px;width:300px}.background{fill:#ccc;pointer-events:all}.map-layer{fill:#08304b;stroke:orange;stroke-width:1px}.leaflet-bottom,.leaflet-top{z-index:999!important}", ""]);
// Exports
module.exports = exports;
